import axios from 'axios'
import qs from 'qs'
import { Message, Loading, MessageBox } from 'element-ui'
import { v4 as uuidv4 } from 'uuid'
import router from '../router'
import store from '../store'
import global from '@/constants/Global.constants'

let type
var instance = axios.create({
  timeout: 1000 * 60 * 3
})
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;'
var loadingInstance = null
instance.interceptors.request.use(config => {
  if (Object.prototype.toString.call(config.data) === '[object String]') {
    config.data = config.data + `&asp=${global.DATA_DICT.asp}`
  } else {
    // console.log(config.data, 'www')
    if (!config.data) {
      config.data = {
        asp: global.DATA_DICT.asp
      }
    } else {
      config.data.asp = global.DATA_DICT.asp
    }
  }
  // 添加uuid作为接口的唯一识别
  config.headers.reqId = uuidv4()
  // 登录流程控制中，根据本地是否存在token判断用户的登录情况
  // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
  // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
  // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
  // if (config.url.indexOf('/ec/') > 0 || config.url.indexOf('/dealer/logout') > 0 || config.url.indexOf('/msi/ims') > 0) {
  const token = store.state.token
  token && (config.headers.certificate = token)

  // }
  //  if (!config.headers['Content-Type']) {//为json类型参数统一增加asp参数(ps:尝试了各种方法去区分两种请求头都没用。。。为‘application/x-www-form-urlencoded’时Content-Type为application/json；为‘application/json’时Content-Type为undefined？？？什么鬼？！！)
  //  let data = config.data
  //  let user = JSON.parse(localStorage.getItem('user'))
  //  data.asp = user.asp
  //  data.userId = user.userId
  //  config.data = data
  // }
  loadingInstance = Loading.service({
    fullscreen: true,
    text: '正在加载',
    background: 'rgba(0, 0, 0, 0)'
  })
  return config
},
  error => Promise.error(error)
)

const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      Message.closeAll()
      Message('登录信息失效,请重新登录')
      setTimeout(() => {
        store.dispatch('setToken', '')
        store.dispatch('updateUserInfo', '')
        store.dispatch('clearCartCount')
        localStorage.clear()
        // localStorage.setItem('lastVisitedPage', currentRoute);
        router.push({ path: '/login' })
      }, 1000)
      // MessageBox.alert('关闭提示后重新登录', '登录信息失效', {
      //     confirmButtonText: '确定',
      //     callback: action => {
      //         store.dispatch('setToken', '')
      //         store.dispatch('updateUserInfo', '')
      //         store.dispatch('clearCartCount')
      //         router.push({ path: '/login' })
      //     }
      // })
      break
    // 403 token过期
    // 清除token并跳转登录页
    case 503:
      Message({
        message: '服务器正在更新数据，请稍后重试',
        center: true
      })
      break
    // 404请求不存在
    case 404:
      // tip('请求的资源不存在')
      break
    default:
      console.log(other)
  }
}

instance.interceptors.response.use(res => { // 请求成功
  if (res.data && res.data.code && res.data.code !== '0000' && res.data.message !== '用户状态异常') {
    Message({
      message: res.data.message,
      center: true,
      type: 'warning'
    })
  } else if (res.data && res.data.code && res.data.code !== '0000' && res.data.message === '用户状态异常') {
    Message({
      message: '您的资料正在审核中',
      center: true,
      type: 'warning'
    })
  }
  res.status === 200 && loadingInstance && loadingInstance.close()

  // 获取当前路由信息

  // const currentRoute = router
  // console.log(router,"当前路由")
  // localStorage.setItem('lastVisitedPage', currentRoute.fullPath);
  return res.status === 200 ? Promise.resolve(res) : Promise.reject(res)
},
  error => { // 请求失败
    loadingInstance && loadingInstance.close()
    const {
      response
    } = error
    if (response) {
      console.log(response)
      // 请求已发出，但是不在2xx的范围
      if (response.request.responseURL.indexOf('findAllProject') !== -1) {
        return Promise.reject(response)
      }
      errorHandle(response.status, response.data.message)
      return Promise.reject(response)
    } else {
      console.log(error)
      Message({
        message: '网络异常，请稍后重新尝试',
        center: true,
        type: 'warning'
      })
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      // store.commit('changeNetwork', false)
    }
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/request/http.js